module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0 15px"
    }
  }, [_c('div', {
    attrs: {
      "id": "approveState"
    },
    on: {
      "click": _vm.visibleBox
    }
  }, [(!_vm.stateList || _vm.stateList.length == 0) ? [_c('div', {
    staticClass: "empty-state"
  }, [_vm._v("暂无审批信息")])] : [_c('div', {
    style: ({
      width: (_vm.stateList.length * 250) + 'px'
    })
  }, _vm._l((_vm.stateList), function(state, index) {
    return _c('div', {
      key: state.new_flowapproval_stepsId
    }, [_c('div', {
      staticClass: "node",
      style: (state.new_status !== 0 ? 'width:90px' : ''),
      on: {
        "click": _vm.onClick
      }
    }, [(state.new_status === 0) ? _c('i', {
      staticClass: "node-icon",
      class: {
        'icon-skip': state.new_status === 1 && state.new_name != '', 'icon-approving': state.new_status === 1 && state.new_name == '', 'icon-approved': state.new_status === 2, 'icon-submit': state.new_status === 0
      }
    }) : _c('div', {
      class: {
        'icon-skip': state.new_status === 1 && state.new_name != '', 'icon-approving': state.new_status === 1 && state.new_name == '', 'icon-approved': state.new_status === 2, 'icon-submit': state.new_status === 0
      }
    }, [_vm._v("\n              " + _vm._s(state.new_stepName) + "\n            ")]), _vm._v(" "), _c('ul', {
      style: (state.new_status !== 0 ? 'margin-left:-50px' : 'top: 55px')
    }, [(!(state.new_approvalway === 2 && state.list) && !(state.new_approvalway === 3 && state.list)) ? _c('li', {
      staticClass: "owner"
    }, [_vm._v("\n                " + _vm._s(state.new_userName) + "\n              ")]) : _vm._e(), _vm._v(" "), (state.new_status === 1 && state.list) ? _c('li', {
      staticStyle: {
        "color": "#848383"
      }
    }, [_vm._v("(点击查看审批人)")]) : _vm._e(), _vm._v(" "), (state.new_status === 1 && state.list) ? [(state.new_approvalway == 2) ? _c('li', {
      staticStyle: {
        "color": "#848383"
      }
    }, [_vm._v("所有审批人均需审批")]) : _vm._e(), _vm._v(" "), (state.new_approvalway == 3) ? _c('li', {
      staticStyle: {
        "color": "#848383"
      }
    }, [_vm._v("一人审批即可通过")]) : _vm._e()] : _vm._e(), _vm._v(" "), (state.new_status === 2 && (state.new_approvalway == 2 || state.new_approvalway == 3)) ? [(state.list) ? _c('li', [_vm._l((state.list), function(data, index) {
      return [(data.new_status === 2) ? _c('span', [_vm._v(_vm._s(index ? '，' : '') + _vm._s(data.new_userName))]) : _vm._e()]
    }), _vm._v("\n                  已审批\n                ")], 2) : _vm._e()] : _vm._e()], 2), _vm._v(" "), (state.list) ? [_c('div', {
      ref: "nodeBox",
      refInFor: true,
      staticClass: "node-box",
      staticStyle: {
        "display": "none"
      }
    }, [_c('div', [_c('div', [_vm._v("处理人：")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "padding-left": "15px"
      }
    }, _vm._l((state.list), function(data, index) {
      return _c('div', {
        key: index,
        staticStyle: {
          "width": "100%"
        }
      }, [_c('span', {
        staticClass: "new_userName"
      }, [_vm._v(_vm._s(data.new_userName))]), _vm._v(" "), (!(state.new_approvalway == 3 && state.list[0].new_status === 2 && index)) ? [_c('span', {
        class: {
          'status-color': data.new_status === 2, 'status-color1': data.new_status === 1
        }
      }, [_vm._v("\n                          " + _vm._s(data.new_status === 2 ? '已审批' : '待审批') + "\n                        ")])] : _vm._e()], 2)
    }), 0)])])] : _vm._e()], 2), _vm._v(" "), (index !== _vm.stateList.length - 1) ? _c('div', {
      staticClass: "proce"
    }, [_c('span', [_vm._v("- - - - - - - - - - -")])]) : _vm._e()])
  }), 0)]], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "approveTrack"
    },
    on: {
      "click": _vm.visibleBox
    }
  }, [_c('h3', [_vm._v("历史记录")]), _vm._v(" "), _c('ul', _vm._l((_vm.trackList), function(track, index) {
    return _c('li', {
      key: track.new_flowapproval_logId,
      class: {
        last: index === _vm.trackList.length - 1
      }
    }, [_c('div', {
      staticStyle: {
        "margin-top": "0"
      }
    }, [_c('i', {
      staticClass: "node-icon",
      class: {
        first: index === 0
      }
    }), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(track.new_date))]), _vm._v(" "), _c('span', {
      staticClass: "action"
    }, [_vm._v("[" + _vm._s(track.new_actionName) + "]")]), _vm._v(" "), _c('span', {
      staticClass: "step"
    }, [_vm._v(_vm._s(track.new_stepName))]), _vm._v(" "), _c('span', {
      staticClass: "owner"
    }, [_vm._v(_vm._s(track.new_userName))])]), _vm._v(" "), (track.new_memo != null && track.new_actionName != '驳回到指定步骤' && track.new_actionName != '驳回到申请人') ? _c('div', {
      staticClass: "memo"
    }, [_c('span', [_vm._v("[" + _vm._s(track.new_actionName) + "意见]: " + _vm._s(track.new_memo))])]) : _vm._e(), _vm._v(" "), (track.new_memo != null && (track.new_actionName == '驳回到指定步骤' || track.new_actionName == '驳回到申请人')) ? _c('div', {
      staticClass: "memo"
    }, [_c('span', [_vm._v("[驳回意见]: " + _vm._s(track.new_memo))])]) : _vm._e(), _vm._v(" "), (track.new_result != null) ? _c('div', {
      staticClass: "memo"
    }, [_c('span', [_vm._v("[驳回意见]: " + _vm._s(track.new_result))])]) : _vm._e()])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d5cb39a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/approval/src/progress.vue
// module id = 1411
// module chunks = 116